<template>
  <div class="Fuell-Table--row">
    <div
      class="Fuell-Table--item clickable"
      @click="emitTransaction"
    >
      <div :class="transactionStatusClass">
        {{
            transactionStatusLabel}}

      </div>
    </div>
    <div class="Fuell-Table--item">
      <div class="flex dark">
        <user-name-badge
          :userName="transactionUserNameAndLastName"
          :userAvatarId="transactionUserProfilePictureId"
        />
        <span class="ellipsis">{{ transactionUserNameAndLastName }}</span>

      </div>

    </div>

    <div
      class="Fuell-Table--item clickable transaction-date"
      :class="{ pending: transactionIsPending }"
    >
      <template v-if="transactionDate">
        {{$moment(transactionDate).format('DD/MM/YYYY - HH:mm')}}

        <inline-svg
          :src="require('@/assets/img/icons/icon-watch.svg')"
          v-if="transactionIsPending"
          class="pending-icon"
        />
      </template>
    </div>

    <div
      class="Fuell-Table--item clickable"
      v-tooltip="transactionActivityGroupLabel"
      @click="emitTransaction"
    >
      <div class="flex">
        <user-name-badge
          v-if="!transactionIsDeclined"
          :userName="transactionActivityGroupLabel"
          :userAvatarId="transactionMerchantLogo"
          :backgroundClass="transactionMerchantClass"
        />
        <div
          v-else
          class="declined-badge"
        >
          <img
            class="declined-icon"
            :src="require('@/assets/img/icons/declined-icon.svg')"
            alt="Declined"
          />
        </div>
        <span class="ellipsis">{{ transactionActivityGroupLabel }}</span>
      </div>
    </div>
    <div
      class="Fuell-Table--item clickable dark amount"
      :class="{
        pending: transactionIsPending,
        declined: transactionIsDeclined,
        refund: transactionIsRefund
      }"
      @click="emitTransaction"
    >
      {{
        transactionAmmount
          | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          })
      }}
    </div>

    <!--
    <div class="Fuell-Table--item Fuell-Table--options">
      <button
        v-if="!transactionIsDeclined && !transactionIsAuthorization"
        @click="emitTransaction"
        class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--fixed-width dots"
      >
        <img
          :src="require(`@/assets/img/icons/icon-dots.svg`)"
          alt="options"
        />
      </button>
    </div>-->
  </div>
</template>

<script>
import UserNameBadge from '@/components/Commons/UserNameBadge'
import _transactionsTableRowInfo from '@/modules/transactions/_mixins/_transactionsTableRowInfo'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'BenefitTransactionsTableRow',
  mixins: [_transactionsTableRowInfo],
  props: {
    transaction: {
      type: Object,
      required: true
    }
  },

  methods: {
    emitTransaction () {
      if (
        this.transaction.status.code === 'KO' ||
        this.transaction.amount === 0
      ) {
        return
      }
      this.$emit('showEditTransactionModal', this.transaction.id)
    }
  },
  components: {
    UserNameBadge,
    InlineSvg
  }
}
</script>

<style
    scoped>
.spinner-loading >>> .py-4 {
  height: 24px;
  width: 24px;
  line-height: 24px;
  padding: 0px !important;
}
.pending {
  color: var(--gray);
  opacity: 0.72;
}
.refund {
  color: var(--semantic-positive-main);
}
.transaction-date .pending-icon {
  position: relative;
  left: 2px;
  top: -6px;
}
.declined {
  color: var(--red);
  text-decoration: line-through;
}
.declined-icon {
  width: 20px;
  height: 20px;
}
.declined-badge {
  margin-right: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.02);
}
.amount {
  font-weight: 300;
}
.transaction-status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.transaction-locked-icon {
  width: 16px;
  height: 16px;
  margin-left: auto;
  margin-right: 5px;
}
</style>

<style>
.budgets_select .multiselect__option--disabled {
  background-color: white !important;
  color: var(--gray);
}
</style>
